// src/components/modal.jsx
import React, { useEffect, useLayoutEffect, useState } from "react";
import ReactDOM from "react-dom";

const TRANSITION_MS = 220;

export const Modal = ({ isOpen, onClose, item }) => {
  const [shouldRender, setShouldRender] = useState(isOpen);
  const [isActive, setIsActive] = useState(false);

  // when opening, mount then activate
  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
    }
  }, [isOpen]);

  useLayoutEffect(() => {
    if (shouldRender) {
      const id = requestAnimationFrame(() => setIsActive(true));
      return () => cancelAnimationFrame(id);
    }
  }, [shouldRender]);

  // handle body scroll + ESC
  useEffect(() => {
    if (!shouldRender) return;
    const onEsc = (e) => e.key === "Escape" && handleRequestClose();
    document.addEventListener("keydown", onEsc);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onEsc);
      document.body.style.overflow = prev;
    };
  }, [shouldRender]);

  // exit animation before unmount
  useEffect(() => {
    if (!isOpen && shouldRender) {
      setIsActive(false);
      const t = setTimeout(() => setShouldRender(false), TRANSITION_MS);
      return () => clearTimeout(t);
    }
  }, [isOpen, shouldRender]);

  if (!shouldRender || !item) return null;

  const handleRequestClose = () => {
    setIsActive(false);
    setTimeout(() => onClose?.(), TRANSITION_MS);
  };

  const modalUI = (
    <div
      className={`hajasaude-modal ${isActive ? "is-active" : ""}`}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="hajasaude-modal__backdrop"
        onClick={handleRequestClose}
        aria-hidden="true"
      />
      <div className="hajasaude-modal__dialog">
        <button
          className="hajasaude-modal__close"
          onClick={handleRequestClose}
          aria-label="Fechar"
          title="Fechar"
        >
          &times;
        </button>

        {item.headerImage && (
          <div className="hajasaude-modal__media">
            <img
              src={item.headerImage}
              alt={item.title}
              className="hajasaude-modal__headerImage"
            />
          </div>
        )}

        <div className="hajasaude-modal__content">
          <h3 className="hajasaude-modal__title">{item.title}</h3>
          {item.subtitle && <p className="hajasaude-modal__subtitle">{item.subtitle}</p>}
          {item.description && <p className="mb-4">{item.description}</p>}
          {Array.isArray(item.bullets) && item.bullets.length > 0 && (
            <ul className="hajasaude-modal__list">
              {item.bullets.map((b, i) => (
                <li key={i}>{b}</li>
              ))}
            </ul>
          )}
          {item.clinic && <p className="mb-4" style={{marginTop: "8px"}}>{item.clinic}</p>}
          {Array.isArray(item.bullets_clinic) && item.bullets_clinic.length > 0 && (
            <ul className="hajasaude-modal__list">
              {item.bullets_clinic.map((b, i) => (
                <li key={i}>{b}</li>
              ))}
            </ul>
          )}
          {item.footer && <p className="hajasaude-modal__footer">{item.footer}</p>}
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalUI, document.body);
};
